import { render } from "./index.vue?vue&type=template&id=4a8b8d88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4a8b8d88&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8b8d88"],['__file',"src/views/MyAccount/MyProfile/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a8b8d88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a8b8d88', __exports__)) {
    console.log('reload')
    api.reload('4a8b8d88', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4a8b8d88&scoped=true", () => {
    console.log('re-render')
    api.rerender('4a8b8d88', render)
  })

}


export default __exports__